<template>
  <v-dialog
    v-model="dialog"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="ok"
    fullscreen full-width
  >
  <div style="height:100%; width:100%; text-align-last: center; background-color: rgba(74, 74, 74, 0.5)">
      <v-progress-circular
        style="height:90%; width:100px"
        indeterminate
        color="primary">
    </v-progress-circular>
  </div>
    
  </v-dialog>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props:{
      dialog: Boolean
  },
  data() {
    return {
      options: {
        zIndex: 200,
      }
    };
  }
};
</script>